import React, { useState, useRef, useEffect} from 'react';
import { useNavigate, NavLink, useParams  } from 'react-router-dom';
import { useForm, useFieldArray } from 'react-hook-form';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import apiService from './../../Auth/apiService.jsx';
import AddressGenerator from '../Caracterizacion/Personas/AdressGenerator.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import Months from './../AppParametros/months.jsx';
import Years from './../AppParametros/Years.jsx';
import MenuReincorporados from './MenuReincorporados.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { FaMap } from 'react-icons/fa';

export default function Ubicacionrei(){
    const hasRun = useRef(false);
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { idCabezaFamilia } = useParams();
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const hideModal = () => setShow(false);
    const [barrios, setBarrios] = useState([]);
    const [comuna, setComuna] = useState('');
    const [zona, setZona] = useState('');
    const [asentamientos, setAsentamientos] = useState([]);
    const [asentamientosBarrio, setAsentamientosBarrio] = useState([]);
    const [tiposvivienda, setTiposvivienda] = useState([]);
    const [tipostenencia, setTipostenencia] = useState([]);
    const [formasasentamiento, setFormasasentamiento] = useState([]);
    const [porqueescogiomedellin, setPorqueescogiomedellin] = useState([]);
    const [tiposexpectativaubicacion, setTiposexpectativaubicacion] = useState([]);
    const [municipiosdto, setMunicipiosdto] = useState([]);
    const [tiposlugar, setTiposlugar] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [FormCabezaFamilia, setFormCabezaFamilia] = useState([]);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
      });
    const {register, handleSubmit, control, setValue, reset, watch, getValues, formState: { errors }} = useForm({
        defaultValues: {
            porquemedellinfields: []
        }
      });
    const cab_formaasenid = watch('cab_formaasenid');
    const cab_tipoexpectativaubiid = watch('cab_tipoexpectativaubiid');
    const { append, remove } = useFieldArray({
        control,
        name: 'porquemedellinfields'
      });
    function setDireccionPrincipal(data){
        setValue('cab_direccion', data);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/reincorporados/actualizarubicacion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
               Mensaje('Guardar ubicacion', JSON.stringify(response.data));
               navigate(`/reincorporados/grupofamiliarrei/${idCabezaFamilia}`);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
          setCargando(false);
        }
      };

    const SeleccionarAsentamientos = React.useCallback(async (idBarrio) => {
        setComuna(barrios.find(v => v.id === idBarrio)?.comComuna || '');
        setZona(barrios.find(v => v.id === idBarrio)?.zonZona || '');
        setAsentamientosBarrio(asentamientos.filter((item) => item.aseBarrioid === idBarrio)); 
    }, [barrios, asentamientos]);

    useEffect(() => {
        if (barrios.length > 0 && CabezaFamiliaDatos.cab_barrio) {
            SeleccionarAsentamientos(CabezaFamiliaDatos.cab_barrio);
        }
    }, [barrios, SeleccionarAsentamientos, CabezaFamiliaDatos.cab_barrio]);
    
    const setFormValuesFromCabezaFamilia = (cabezafamilia) => {
        if (cabezafamilia) {
            reset((prevValues) => ({
                ...prevValues,
                ...cabezafamilia,
                cab_barrio: cabezafamilia.cab_barrio || "",
                cab_tipoexpectativaubiid: String(cabezafamilia.cab_tipoexpectativaubiid),
                usrId: user,
                cabIdcabezafamilia: idCabezaFamilia,
            }));
            setValue('cab_formaasenid', cabezafamilia.cab_formaasenid);
            setValue('cab_porqueubicacion', cabezafamilia.cab_porqueubicacion);
        }
    };

    useEffect(() => {
        if (!hasRun.current) {
            // Helper to set array state or log error
            const setArrayStateOrError = (data, setter, label) => {
                if (Array.isArray(data)) {
                    setter(data);
                } else {
                    console.error(`Invalid data for ${label}:`, data);
                }
            };

            const fetchData = async () => {
                const url = '/reincorporados/crearformularioubicacion';
                const obj = { idCabezaFamilia: idCabezaFamilia };
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    
                    setArrayStateOrError(result.asentamientos, setAsentamientos, 'asentamientos');
                    setArrayStateOrError(result.tiposvivienda, setTiposvivienda, 'tiposvivienda');
                    setArrayStateOrError(result.tipostenencia, setTipostenencia, 'tipostenencia');
                    setArrayStateOrError(result.formasasentamiento, setFormasasentamiento, 'formasasentamiento');
                    setArrayStateOrError(result.porqueescogiomedellin, setPorqueescogiomedellin, 'porqueescogiomedellin');
                    setArrayStateOrError(result.tiposexpectativaubicacion, setTiposexpectativaubicacion, 'tiposexpectativaubicacion');
                    setArrayStateOrError(result.municipiosdto, setMunicipiosdto, 'municipiosdto');
                    setArrayStateOrError(result.tiposlugar, setTiposlugar, 'tiposlugar');
                    setArrayStateOrError(result.barrios, setBarrios, 'barrios');
                    
                    setCabezaFamiliaDatos(result.cabezafamilia);
                    setFormCabezaFamilia(result.cabezafamilia);

                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setCargando(false);
                }
            };
            fetchData();
            hasRun.current = true;
        }
    }, [idCabezaFamilia, setValue, user, reset, token]);
    useEffect(() => {
        if (barrios.length > 0 && FormCabezaFamilia?.cab_barrio) {
            setFormValuesFromCabezaFamilia(FormCabezaFamilia);
        }
    }, [barrios, FormCabezaFamilia]);
    const handleCheckboxFormaAsentamientoChange = (event) => {
        const { value } = event.target;
        setValue('cab_formaasenid', value)
    };

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const handleUppercase = (event) => {
        const uppercasedValue = event.target.value.toUpperCase();
        const fieldname = event.target.name;
        setValue(fieldname, uppercasedValue);
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Ubicaci&oacute;n del hogar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> persona</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-primary">
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                            <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                            <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Ubicaci&oacute;n en Medell&iacute;n</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="cab_barrio">Barrio o Vereda:</label>
                                        <select id="cab_barrio" {...register('cab_barrio', { required: true })} className='form-control' onChange={(e => SeleccionarAsentamientos(e.target.value))}>
                                            <option value="">Seleccionar</option>
                                            {barrios.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.barBarrio}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.cab_barrio && <p style={{color: 'red'}}>Seleccione barrio</p>}
                                    </div>
                                </div>
                                {comuna !== '' && <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="cab_comuna">Comuna/Corregimiento:</label>
                                        <input
                                            id="cab_comuna"
                                            className="form-control"
                                            value={comuna}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="cab_zona">Zona:</label>
                                        <input
                                            id="cab_zona"
                                            className="form-control"
                                            value={zona}
                                            disabled
                                        />
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="cab_viveasentamiento">¿El Hogar vive o se ubica en un Asentamiento?</label>
                                        <select id="cab_viveasentamiento" {...register('cab_viveasentamiento', { required: true })} className='form-control'>
                                            <option value="">Seleccionar</option>
                                            <option value="SI">SI</option>
                                            <option value="NO">NO</option>
                                        </select>
                                        {errors.cab_viveasentamiento && <p style={{color: 'red'}}>Seleccione pregunta</p>}
                                    </div>
                                    {watch('cab_viveasentamiento') === 'SI' && <div  className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_asentamientoid">Nombre del Asentamiento</label>
                                            <select id="cab_asentamientoid" {...register('cab_asentamientoid', { validate: value => {
                                                        if (watch('cab_viveasentamiento') == 'SI' && !value) {
                                                        return 'Seleccione pregunta asentamiento';
                                                        }
                                                        return true;
                                                    }
                                                    })}
                                                    className='form-control'>
                                                <option value="">Seleccionar</option>
                                                {asentamientosBarrio.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.aseAsentamiento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_asentamientoid && <p style={{color: 'red'}}>Seleccione asentamiento</p>}
                                        </div>
                                    </div>}
                                    <div hidden className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="nuevoasentamiento">Nuevo Asentamiento:</label>
                                            <input id="nuevoasentamiento" {...register('nuevoasentamiento')}  className="form-control" placeholder="Nuevo asentamiento"/>
                                            {errors.nuevoasentamiento && <p style={{color: 'red'}}>Digite nuevo asentamiento</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono1">Tel&eacute;fono:</label>
                                            <input id="cab_telefono1" {...register('cab_telefono1', { required: true })}  className="form-control" placeholder="Telefono 1"/>
                                            {errors.cab_telefono1 && <p style={{color: 'red'}}>Digite telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono2">Otro Tel&eacute;fono:</label>
                                            <input id="cab_telefono2" {...register('cab_telefono2')}  className="form-control" placeholder="Telefono 2"/>
                                            {errors.cab_telefono2 && <p style={{color: 'red'}}>Digite otro telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_celular">Celular:</label>
                                            <input id="cab_celular" {...register('cab_celular')}  className="form-control" placeholder="Celular"/>
                                            {errors.cab_celular && <p style={{color: 'red'}}>Digite celular</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_correoelectronico">Correo Electr&oacute;nico:</label>
                                            <input id="cab_correoelectronico" {...register('cab_correoelectronico')}  className="form-control" placeholder="Correo Electronico"/>
                                            {errors.cab_correoelectronico && <p style={{color: 'red'}}>Digite correo electronico</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="cab_direccion">Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input {...register('cab_direccion', { required: true })}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModal}>
                                                        <FaMap color="black" /> Generar dir. 
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.cab_direccion && <p style={{color: 'red'}}>Digite direccion</p>}
                                            
                                        </div>
                                        <AddressGenerator show={show} handleClose={hideModal} setDireccion={setDireccionPrincipal}>
                                            <div>Este direccion</div>
                                        </AddressGenerator>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Datos vivienda</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_tipovivienda">Tipo Vivienda</label>
                                            <select {...register('cab_tipovivienda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposvivienda.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTipovivienda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_tipovivienda && <p style={{color: 'red'}}>Seleccione tipo de vivienda</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_tipotenencia">Forma de Tenencia</label>
                                            <select {...register('cab_tipotenencia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tipostenencia.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTenencia}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_tipotenencia && <p style={{color: 'red'}}>Seleccione tipo de tenencia</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div hidden className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Criterios de llegada a Medell&iacute;n</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <input hidden {...register('cab_formaasenid')}/> 
                                        {formasasentamiento.map((item) => (
                                             <div key={item.id}>
                                                <label 
                                                data-tooltip-id="tooltiparriba"
                                                data-tooltip-content={item.forAyuda}>
                                                    <input
                                                    width={100}
                                                    type="radio"
                                                    name="options"
                                                    value={item.id}
                                                    checked={cab_formaasenid === item.id}
                                                    onChange={handleCheckboxFormaAsentamientoChange}
                                                    />
                                                    
                                                    {item.forForma}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <h5>Fecha de llegada a Medellìn:</h5>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_anyollegadaret">Año:</label>
                                            <select id="cab_anyollegadaret" {...register('cab_anyollegadaret')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {Years.map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_anyollegadaret && <p style={{color: 'red'}}>Seleccione año de llegada</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_mesllegadaret">Mes:</label>
                                            <select id="cab_mesllegadaret" {...register('cab_mesllegadaret')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {Months.map((month) => (
                                                <option key={month.id} value={month.id}>
                                                    {month.name}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_mesllegadaret && <p style={{color: 'red'}}>Seleccione mes de llegada</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div hidden className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Expectativas de ubicaci&oacute;n</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="cab_tipoexpectativaubiid">¿El Hogar desea?</label>
                                                <select id="cab_tipoexpectativaubiid" {...register('cab_tipoexpectativaubiid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposexpectativaubicacion.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tipTipoexpectativaubicacion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.cab_tipoexpectativaubiid && <p style={{color: 'red'}}>Seleccione tipo expectativa</p>}
                                            </div>
                                        </div>
                                        {(cab_tipoexpectativaubiid != '1' && cab_tipoexpectativaubiid != '5') && <div className="col-md-6">
                                            <div className="form-group" >
                                                <label htmlFor="cab_municipioubicacionid">MUNICIPIO donde desea reubicarse</label>
                                                <select {...register('cab_municipioubicacionid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {municipiosdto.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.dep_departamento} - {item.mun_municipio}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.cab_municipioubicacionid && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                            </div>
                                        </div>}
                                    </div>
                                    {(cab_tipoexpectativaubiid != '1' && cab_tipoexpectativaubiid != '5') && <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="cab_tipoentornoid">¿A qu&eacute; lugar exacto?</label>
                                                <select {...register('cab_tipoentornoid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposlugar.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tipTipolugar}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.cab_tipoentornoid && <p style={{color: 'red'}}>Seleccione tipo entorno</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="form-group" >
                                                <label htmlFor="cab_nombreentorno">Nombre del barrio, o de la vereda, o del corregimiento.</label>
                                                <input id="cab_nombreentorno" {...register('cab_nombreentorno')} onChange={handleUppercase} className="form-control" placeholder="Nombre entorno"/>
                                                {errors.cab_nombreentorno && <p style={{color: 'red'}}>Digite nombre entorno</p>}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>

                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                            <button type="submit" className="btn btn-primary">Guardar</button>
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}